import { render, staticRenderFns } from "./ChecklistEditor.vue?vue&type=template&id=2f8138b4&scoped=true&"
import script from "./ChecklistEditor.vue?vue&type=script&lang=js&"
export * from "./ChecklistEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistEditor.vue?vue&type=style&index=0&id=2f8138b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8138b4",
  null
  
)

export default component.exports